/* eslint-disable import/no-cycle */
import React from 'react';
import { WrappedFunctionProps } from '../types';
import { SelectOptionsField } from '../../apiForm/form/input';

export default function SelectField({
  inputKey,
  translation,
  language,
  control,
  data,
}: WrappedFunctionProps) {
  const options =
    data?.enum?.map((option: string) => ({
      option,
      translation: translation?.enumNames?.[option] || option,
    })) || [];
  return (
    <SelectOptionsField
      control={control}
      name={inputKey}
      label={translation?.title?.[language] || inputKey}
      helperText={translation?.description?.[language]}
      options={options}
      valueFrom="option"
      labelFrom={`translation.${language}`}
      multiple
    />
  );
}
